import React from "react";
import Exterior from "../../../assets/office-photos/exterior.jpeg";
import WaitingRoom from "../../../assets/office-photos/waiting-room.jpeg";
import Cards from "../../../assets/office-photos/cards.jpeg";
import Entrance from "../../../assets/office-photos/entrance.jpeg";
import Quest from "../../../assets/office-photos/quest.jpeg";
import FrontDesk from "../../../assets/office-photos/front-desk.jpeg";
import ConsultOne from "../../../assets/office-photos/consult-one.jpeg";
import ConsultTwo from "../../../assets/office-photos/consult-two.jpeg";
import ConsultThree from "../../../assets/office-photos/consult-three.jpeg";
import ConsultFour from "../../../assets/office-photos/consult-four.jpeg";

import "./HomeOfficePhotos.css";

const HomeOfficePhotos = () => {
  return (
    <section className="home-office-photos">
      <div className="photos-container">
        <img src={Exterior} alt="Entrance" id="exterior-logo" />
        <img src={Entrance} alt="Lobby" id="lobby" />
        <img src={ConsultOne} alt="Hallway" id="hallway" />
        <img src={Cards} alt="Infusion Room" id="infusion-room" />
        <img src={Quest} alt="Infusion Room Chairs" id="infusion-chairs-2" />
        <img src={ConsultFour} alt="Exam room" id="exam-room" />
        <img src={ConsultThree} alt="Colorful art" id="exam-room-wall" />
      </div>
    </section>
  );
};

export default HomeOfficePhotos;
